import React from 'react';
import { BaseFeaturedSearchCard } from '../Base/Featured';
import styled from 'styled-components';
import { theme } from '../../../../theme';
import { SearchCard } from '../types';
import { GrayUIText, Title, BottomContent } from '../Base/styles';
import {
  BoxConditionIcon,
  TruckIcon,
  MapMarkerIcon,
  PhoneIcon,
} from '../../../../assets';
import { Pill } from '../../../basePill';

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacings[2].rem};
  margin: ${theme.spacings[2].rem};
  width: 149px;
`;

export const AssetForSaleFeaturedSearchCard: React.FC<
  SearchCard<'AssetForSale'>
> = ({
  title,
  price,
  condition,
  location,
  isDelivery,
  data,
  type,
  ...props
}) => {
  return (
    <BaseFeaturedSearchCard {...props}>
      <Content>
        <Title>{title}</Title>

        <Pill
          backgroundColor={theme.colors.neutrals.transparentGrays[6]}
          icon={PhoneIcon}
        >
          {data.pillText}
        </Pill>
        <BottomContent>
          <GrayUIText>
            <BoxConditionIcon
              width={16}
              fill={theme.colors.primary.graysGray}
            />
            {condition}
          </GrayUIText>
          {(condition as string).length < 13 && (
            <GrayUIText>
              {isDelivery ? (
                <>
                  <TruckIcon width={16} fill={theme.colors.primary.graysGray} />
                  Delivery
                </>
              ) : (
                <>
                  <MapMarkerIcon
                    width={16}
                    fill={theme.colors.neutrals.solidGrays[3]}
                  />
                  {location}
                </>
              )}
            </GrayUIText>
          )}
        </BottomContent>
      </Content>
    </BaseFeaturedSearchCard>
  );
};
